/**
 * Lumen Health – Sprechstunde Modal
 * ══════════════════════════════════════════════════════════
 *
 * SETUP (einmalig in Shopify):
 * ─────────────────────────────
 * 1. Shopify Admin → Produkte → "Neu"
 *    - Name:       "Ärztliche Sprechstunde"
 *    - Preis:      39,00 €  (oder gewünschter Preis)
 *    - Sichtbarkeit: KEINEN Vertriebskanal auswählen (unsichtbar)
 *    - Variante anlegen, Varianten-ID kopieren
 *
 * 2. SPRECHSTUNDE_VARIANT_ID unten eintragen
 *    Die Varianten-ID findest du im Shopify Admin unter:
 *    Produkte → Sprechstunde → URL enthält /variants/XXXXXXXXXX
 *
 * 3. sprechstunde.js in theme.liquid vor </body> einbinden:
 *    <script src="{{ 'sprechstunde.js' | asset_url }}" defer></script>
 *
 * ══════════════════════════════════════════════════════════
 */

(function () {
  'use strict';

  // ─── KONFIGURATION ───────────────────────────────────────
  const CONFIG = {
    // Variante "Einzeln" (30 EUR). Die Paket-Variante "Im Paket" (20 EUR,
    // 58520057053528) wird NICHT hier angeboten, sondern direkt auf der
    // Produktseite in der Umfang-Auswahl. Siehe CLAUDE.md.
    SPRECHSTUNDE_VARIANT_ID: 58520057020760,
    SPRECHSTUNDE_PRICE: '30,00€',
    OPEN_DELAY: 400,
    SHOW_ON_ALL_PRODUCTS: true,
    CART_URL: '/cart',
  };
  // ─────────────────────────────────────────────────────────

  let selectedOption = 'no';
  let isProcessing = false;
  let currentProductName = 'Deine Bestellung';

  const HEADLINE_TEXT = {
    default: 'Möchtest du eine ärztliche Sprechstunde dazubuchen?',
    einschaetzung: 'Möchtest du eine ärztliche Sprechstunde dazubuchen?',
    folgebehandlung: 'Fragen zu deiner Verlaufskontrolle?',
  };
  const SUBTITLE_TEXT = {
    default: 'Ein unabhängiger Partnerarzt bespricht deine Ergebnisse mit dir persönlich und beantwortet alle offenen Fragen.',
    einschaetzung: 'Ein unabhängiger Partnerarzt bespricht deine ärztliche Einschätzung mit dir persönlich und beantwortet alle offenen Fragen.',
    folgebehandlung: 'Ein unabhängiger Partnerarzt geht deine Verlaufswerte mit dir durch und beantwortet offene Fragen.',
  };
  const OPTION_DESC_TEXT = {
    default: 'Nur das Test-Kit',
    einschaetzung: 'Nur die Therapieprüfung',
    folgebehandlung: 'Nur die Verlaufskontrolle',
  };

  const overlay       = document.getElementById('lh-modal-overlay');
  const modal         = document.getElementById('lh-modal');
  const closeBtn      = document.getElementById('lh-modal-close');
  const confirmBtn    = document.getElementById('lh-btn-confirm');
  const cartBtn       = document.getElementById('lh-btn-cart');
  const btnText       = document.getElementById('lh-btn-text');
  const optionYes     = document.getElementById('lh-option-yes');
  const optionNo      = document.getElementById('lh-option-no');
  const priceEl       = document.getElementById('lh-sprechstunde-price');
  const productNameEl = document.getElementById('lh-product-name');
  const variantNameEl = document.getElementById('lh-variant-name');
  const subtitleEl    = document.getElementById('lh-modal-subtitle');
  const optionDescEl  = document.getElementById('lh-option-desc-no');
  const headlineEl    = document.getElementById('lh-modal-headline');

  if (!overlay) return;

  // ─── INFO-TEXT (statisch, über dem Button) ───────────────
  if (confirmBtn) {
    confirmBtn.insertAdjacentHTML('beforebegin', `
      <p id="ls-info-text"
        style="font-size:12px;color:#6b7280;
          text-align:center;margin:12px 0 0;
          line-height:1.5;display:none;">
        Mit der Buchung stimmst du zu, dass
        deine Beratung ausschließlich über
        digitale Kommunikationswege stattfindet.
        <a href="/pages/fernbehandlung"
          target="_blank"
          style="color:#1a2744;text-decoration:underline;">
          Hinweise zur Fernbehandlung
        </a>
      </p>`
    );
  }

  const infoText = document.getElementById('ls-info-text');

  if (priceEl) priceEl.textContent = '+' + CONFIG.SPRECHSTUNDE_PRICE;

  // ─── MODAL ÖFFNEN / SCHLIESSEN ───────────────────────────

  function openModal(productName, variantTitle, textState) {
    const hasVariant = !!variantTitle && variantTitle !== 'Default Title';
    const displayName = hasVariant ? productName + ' · ' + variantTitle : productName;
    if (productNameEl && productName) productNameEl.textContent = productName;
    if (variantNameEl) {
      if (hasVariant) {
        variantNameEl.textContent = '· ' + variantTitle;
        variantNameEl.style.display = 'block';
      } else {
        variantNameEl.textContent = '';
        variantNameEl.style.display = 'none';
      }
    }
    currentProductName = displayName || 'Deine Bestellung';
    if (headlineEl) {
      headlineEl.textContent = HEADLINE_TEXT[textState] || HEADLINE_TEXT.default;
    }
    if (subtitleEl) {
      subtitleEl.textContent = SUBTITLE_TEXT[textState] || SUBTITLE_TEXT.default;
    }
    if (optionDescEl) {
      optionDescEl.textContent = OPTION_DESC_TEXT[textState] || OPTION_DESC_TEXT.default;
    }
    selectedOption = 'no';
    updateSelection('no');
    overlay.classList.add('lh-overlay--visible');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => modal?.classList.add('lh-modal--visible'), 10);
  }

  function closeModal() {
    modal?.classList.remove('lh-modal--visible');
    setTimeout(() => {
      overlay.classList.remove('lh-overlay--visible');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }, 300);
  }

  // ─── AUSWAHL-LOGIK ───────────────────────────────────────

  function updateSelection(value) {
    selectedOption = value;
    optionYes?.classList.toggle('lh-option--selected', value === 'yes');
    optionNo?.classList.toggle('lh-option--selected', value === 'no');
    const radio = overlay.querySelector(`input[value="${value}"]`);
    if (radio) radio.checked = true;
    if (btnText) {
      btnText.textContent = value === 'yes'
        ? 'Sprechstunde hinzufügen & weiter'
        : 'Weiter zum Warenkorb';
    }
    if (infoText) {
      infoText.style.display = value === 'yes' ? 'block' : 'none';
    }
  }

  optionYes?.addEventListener('click', () => updateSelection('yes'));
  optionNo?.addEventListener('click', () => updateSelection('no'));
  overlay.querySelectorAll('input[name="sprechstunde"]').forEach(radio => {
    radio.addEventListener('change', (e) => updateSelection(e.target.value));
  });

  // ─── SHOPIFY CART API ─────────────────────────────────────

  async function isSprechstundeInCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      return cart.items.some(item => item.variant_id === CONFIG.SPRECHSTUNDE_VARIANT_ID);
    } catch {
      return false;
    }
  }

  async function addToCart(variantId, quantity = 1, properties = null) {
    const item = { id: variantId, quantity };
    if (properties) item.properties = properties;
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: [item] }),
    });
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.description || 'Fehler beim Hinzufügen');
    }
    return response.json();
  }

  // ─── CONFIRM-BUTTON ──────────────────────────────────────

  confirmBtn?.addEventListener('click', async () => {
    if (isProcessing) return;

    const checkedRadio = overlay.querySelector('input[name="sprechstunde"]:checked');
    const wantsSprechstunde = checkedRadio?.value === 'yes' || selectedOption === 'yes';
    const qty = window.__cartQty || 1;

    if (!wantsSprechstunde) {
      window.location.href = CONFIG.CART_URL;
      return;
    }

    isProcessing = true;
    confirmBtn.disabled = true;
    if (btnText) btnText.textContent = 'Wird hinzugefügt…';

    try {
      await addToCart(CONFIG.SPRECHSTUNDE_VARIANT_ID, 1, { '_booking_type': 'upsell' });
      if (btnText) btnText.textContent = qty > 1
        ? qty + '× ' + currentProductName + ' wurden dem Warenkorb hinzugefügt.'
        : 'Dein ' + currentProductName + ' wurde dem Warenkorb hinzugefügt.';
      await new Promise(r => setTimeout(r, 600));
      window.location.href = CONFIG.CART_URL;
    } catch (error) {
      console.error('[Lumen] Sprechstunde konnte nicht hinzugefügt werden:', error);
      confirmBtn.disabled = false;
      if (btnText) btnText.textContent = 'Sprechstunde hinzufügen & weiter';
      alert('Fehler beim Hinzufügen. Bitte erneut versuchen.');
    } finally {
      isProcessing = false;
    }
  });

  cartBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    window.location.href = CONFIG.CART_URL;
  });

  closeBtn?.addEventListener('click', closeModal);
  overlay?.addEventListener('click', (e) => {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('lh-overlay--visible')) {
      closeModal();
    }
  });

  // ─── ADD-TO-CART INTERCEPTOR (CAPTURE PHASE) ─────────────
  // Capture phase = feuert VOR Dawns form-level submit handler.
  // stopPropagation() verhindert dass Dawns onSubmitHandler läuft.
  // Dadurch kein Doppel-Add und kein konkurrierender Cart Drawer.

  document.addEventListener('submit', async function (e) {
    const form = e.target;

    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.dataset.skipUpsell === 'true') return;
    if (!CONFIG.SHOW_ON_ALL_PRODUCTS && form.dataset.sprechstunde === 'false') return;

    // Skip modal for digital/service products
    const productType = document.querySelector('[data-product-type]')?.dataset.productType || '';
    const digitalTypes = ['sprechstunde', 'digital', 'service', 'beratung', 'online'];
    const isDigital = digitalTypes.some(t => productType.toLowerCase().includes(t));
    if (isDigital) return;

    e.preventDefault();
    e.stopPropagation(); // Dawn's onSubmitHandler wird nicht mehr aufgerufen

    const qty = window.__lsQty != null ? window.__lsQty : parseInt(document.querySelector('input[name="ls-qty"]:checked')?.value || 1);
    window.__cartQty = qty;
    window.__lsQty = null;

    const formData = new FormData(form);

    // Sprechstunde selbst nicht abfangen
    const addedId = Number(formData.get('id'));
    if (addedId === CONFIG.SPRECHSTUNDE_VARIANT_ID) return;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        form.dispatchEvent(new Event('submit', { bubbles: true }));
        return;
      }

      const data = await response.json();
      const productName = data.product_title || data.items?.[0]?.product_title || 'Deine Bestellung';
      const variantTitle = data.variant_title || data.items?.[0]?.variant_title || '';
      // Ärztliche Einschätzung (unverlinktes Produkt) an den Varianten-IDs erkennen, nicht am Handle
      const addedVariantId = Number(data.variant_id || data.items?.[0]?.variant_id || 0);
      const isEinschaetzung = [57767845921112, 57767845953880].includes(addedVariantId);
      const isFolgebehandlung = addedVariantId === 57767845953880;
      const textState = isFolgebehandlung ? 'folgebehandlung' : isEinschaetzung ? 'einschaetzung' : 'default';

      const alreadyInCart = await isSprechstundeInCart();
      if (alreadyInCart) {
        window.location.href = CONFIG.CART_URL;
        return;
      }

      setTimeout(() => openModal(productName, variantTitle, textState), CONFIG.OPEN_DELAY);

    } catch (err) {
      console.error('[Lumen] Cart-Fehler:', err);
      window.location.href = CONFIG.CART_URL;
    }

  }, true); // ← true = capture phase

})();
